<div
  fxLayout="row"
  fxLayoutAlign="end"
  fxLayoutGap="2%"
  fxLayout.lt-md="column"
  class="container m-b-20"
>
  <!-- <button mat-raised-button color="primary" [routerLink]="['/dashboard']">
    <fa-icon icon="tachometer-alt"></fa-icon>&nbsp;&nbsp;
    {{ "HOME.DASHBOARD" | translate }}
  </button> -->
</div>

<div class="container">
  <mat-card>
    <mat-card-header>
      <mat-card-title class="title">
        {{ "HOME.WELCOME_MESSAGE" | translate : { username: username } }}
      </mat-card-title>
    </mat-card-header>

    <img mat-card-image src="assets/images/mifos_lg-logo.jpg" alt="Mifos X" />
  </mat-card>
</div>
